var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.04758 0.628951C0.80793 0.399725 0.419379 0.399725 0.179734 0.628951C-0.0599113 0.858184 -0.0599113 1.22983 0.179734 1.45905L1.79133 3.00061L0.17975 4.54216C-0.0598949 4.77132 -0.0598949 5.14299 0.17975 5.37222C0.419395 5.60146 0.807947 5.60146 1.04758 5.37222L2.6592 3.83075L4.27074 5.37222C4.5104 5.60146 4.89897 5.60146 5.13862 5.37222C5.37827 5.14299 5.37827 4.77132 5.13862 4.54208L3.52699 3.00061L5.13862 1.45905C5.37827 1.22985 5.37827 0.8582 5.13862 0.628974C4.89897 0.39974 4.5104 0.39974 4.27074 0.628974L2.6592 2.17047L1.04758 0.628951Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagClose);
export default __webpack_public_path__ + "static/media/tagClose.86cb4dece9bef345f26313b17b51d53f.svg";
export { ForwardRef as ReactComponent };